<template>
<!--    <b-row>-->
<!--        <b-col class="mx-auto" cols="9">-->
<!--            <b-card header="Your Eligibility Results">-->
<!--                <p>Unfortunately, based on your checklist responses, you are not eligible for this type of visa application. Your migration agent will be in contact with you shortly to discuss any alternate options that may exist.-->
<!--                </p>-->
<!--                <p>-->
<!--                    Alternatively, if you would like to contact your migration agent, their contact details are as follows:-->
<!--                </p>-->
<!--                <div class="mt-5">-->
<!--                    <p>-->
<!--                        <strong class="text-primary">{{ caseManagerName }}</strong>-->
<!--                        <br>-->
<!--                        <span class="text-600" v-if="caseManagerEmail">Email: </span>{{ caseManagerEmail }}-->
<!--                        <br>-->
<!--                        <span class="text-600" v-if="caseManagerPhone">Phone: </span>{{ caseManagerPhone }}-->
<!--                    </p>-->
<!--                </div>-->
<!--            </b-card>-->
<!--        </b-col>-->
<!--    </b-row>-->


  <div class="bg-gray-100 dark:bg-darkPrimary mb-4 rounded-md relative pt-4 lg:pt-0 overflow-y-auto overflow-x-hidden h-screen">
    <div class="pb-6 text-center lg:text-center max-w-2xl mx-auto">
      <h1 class="text-2xl lg:text-4xl dark:text-darkTextLight font-semibold mt-8">
        Your Eligibility Results
      </h1>
      <br />
    </div>
    <div class="bg-white dark:bg-coolGray-800 rounded-lg px-16 pb-16 overflow-x-auto flex-1 md:max-w-2xl md:mx-auto m-2">
      <div class="flex justify-center mt-8">
        <div class="grid gird-cols-1 gap-4 mb-4 mt-4">
          <div class="ml-2"><AlertCircleIcon size="3x" class="mt-0.5 mr-1 text-red-400" /></div>
          <div class="text-red-400 font-semibold text-xl">Oh No!</div>
        </div>
      </div>
      <div class="text-center">
        <p class="mt-4">Unfortunately, based on your checklist responses, <span class="font-semibold">you are not eligible for this type of visa application.</span> Your migration agent will be in contact with you shortly to discuss any alternate options that may exist.</p>
        <p class="mt-4">Alternatively, if you would like to contact your migration agent, their contact details are as follows:</p>
      </div>
      <div>
        <h3 class="font-semibold mt-8">{{ caseManagerName }}</h3>
        <a :href="'mailto:'+caseManagerEmail" class="flex mt-4 text-black"><MailIcon size="1x" class="mt-1 mr-6 text-gray-600" />{{ caseManagerEmail }}</a>
        <p class="flex mt-4"><PhoneIcon size="1x" class="mt-1 mr-6 text-gray-600" /><a :href="'tel:'+caseManagerPhone">{{ caseManagerPhone }}</a></p>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import {mapActions} from "vuex";
import { MailIcon, HomeIcon, PhoneIcon, AlertCircleIcon } from 'vue-feather-icons';
export default {
    name: 'not-eligible',
  components: {
    MailIcon,
    HomeIcon,
    PhoneIcon,
    AlertCircleIcon
  },
    computed: {
        caseManager() {
            let project = this.getProject();
            return project.case_manager
        },
        caseManagerName() {
            return this.caseManager ? this.caseManager.name : ''
        },
        caseManagerEmail() {
            return this.caseManager ? this.caseManager.email : ''
        },
        caseManagerPhone() {
            return this.caseManager ? this.caseManager.contact_phone : ''
        }
    },
  methods: {
    ...mapActions({
      setShowFooter: 'client/setShowFooter'
    }),

  },
    mounted() {
        this.setShowFooter(false);
    }
}
</script>